import Skeleton from "components/shared/skeleton";
import ChartBox from "components/skeleton/chart-box";
import { memo } from "react";

const TinyListSkeleton = props => {
    const { hasAll, hasIcon, itemCount } = props;

    return (
        <div className="wrap-box tp-22 mb-4">
            <div className="flex justify-between items-center mb-2">
                <Skeleton className="w-20 h-5 rounded-sm" />

                {
                    !!hasAll && (
                        <Skeleton className="w-20 h-5 rounded-sm" />
                    )
                }
            </div>

            {
                Object.keys([...Array(itemCount)]).map(i => (
                    <div className="flex items-center border-b border-b-[#eee] dark:border-b-[#323244] last:border-0 py-2" key={`tiny-skeleton-${i}`}>
                        {
                            !!hasIcon && (
                                <Skeleton className="w-4 h-4 rounded-full ml-2" />
                            )
                        }

                        <div className="grow">
                            <Skeleton className="w-16 h-4 rounde-sm" />
                        </div>

                        <Skeleton className="w-4 h-4 rounded-full" />
                    </div>
                ))
            }
        </div>
    )
}

const SkeletonComponent = () => (
    <div className="grid grid-cols-12 gap-4">
        <div className="col-span-full xl:col-span-8">
            <Skeleton className="h-32 rounded-md mb-4" />

            <div className="grid grid-cols-4 md:grid-cols-3 gap-4 mb-4">
                {
                    Object.keys([...Array(3)]).map(i => (
                        <div className={`wrap-box tp-22 ${i === 0 ? "col-span-full md:col-span-1" : "col-span-2 md:col-span-1"}`} key={`dashboard-sb1-${i}`}>
                            <Skeleton className="w-16 h-4 rounded-full mb-2" />
                            <Skeleton className="w-32 h-3 rounded-full" />

                            <div className="flex items-center justify-between mt-5">
                                <Skeleton className="w-11 h-11 rounded-full" />
                                <Skeleton className="w-11 h-4 rounded-full" />
                            </div>
                        </div>
                    ))
                }
            </div>

            <ChartBox selectBox={false} />
        </div>

        <div className="col-span-full xl:col-span-4">
            <TinyListSkeleton hasIcon={true} itemCount={4} />
            <TinyListSkeleton hasIcon={true} itemCount={5} />
            <TinyListSkeleton hasAll={true} itemCount={5} />
        </div>
    </div>
)

export default memo(SkeletonComponent);